export const SCOREMAX = 10;
export const GRANULAIRITY = 100;